import {
    buildConfigSlice,
    useConfigSlice,
} from 'widgets/store/configuration/configSlice';
import { WidgetType } from 'widgets/WidgetType';
import {
    initialVenueAnalysisCapsuleConfigState,
    VenueAnalysisCapsuleConfigState,
} from 'widgets/venueAnalysis/capsules/store/VenueAnalysisCapsuleConfigState';
import { selectOrderFillsCapsuleState } from './selectors';
import { useWidgetContext } from 'widgets/WidgetContext';
import { OrderFillsCapsuleWidgetType } from 'widgets/venueAnalysis/capsules/orderFillsCapsulesShared/types/OrderFillsCapsuleWidgetType';

export const buildOrderFillsCapsuleConfigSlice = (
    widgetType: OrderFillsCapsuleWidgetType
) =>
    buildConfigSlice<VenueAnalysisCapsuleConfigState>(
        widgetType,
        selectOrderFillsCapsuleState(widgetType),
        initialVenueAnalysisCapsuleConfigState
    );

export const useOrderFillsCapsuleConfigSlice = () => {
    const { widgetType } = useWidgetContext();
    if (
        widgetType !== WidgetType.ORDER_FILLS_BY_VENUE_CAPSULE &&
        widgetType !== WidgetType.ORDER_FILLS_BY_VENUE_TYPE_CAPSULE
    ) {
        throw new Error('Unexpected widget type ' + widgetType);
    }
    return useConfigSlice(buildOrderFillsCapsuleConfigSlice(widgetType));
};
